module.exports = __webpack_public_path__ + "img/home-banner-1.ad054ecf.jpg";